import { StudentsView } from "../components/principal/StudentsView";

export const Students = () => {
  return <StudentsView />;
};
